import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { CarteiraDeIntegradoresEstatisticasFiltro } from '../models/carteira-de-integradores-estatisticas-filtro';
import { CarteiraDeIntegradoresEstatisticas } from '../models/carteira-de-integradores-estatisticas';
import { CarteiraDeIntegradoresRankingFiltro } from '../models/carteira-de-integradores-ranking-filtro';
import { CarteiraDeIntegradoresItemRanking } from '../models/carteira-de-integradores-item-ranking';

@Injectable({
  providedIn: 'root'
})
export class CarteiraDeIntegradoresService {

  constructor(private http: HttpClient) { }

  consultarEstatisticas(filtro: CarteiraDeIntegradoresEstatisticasFiltro) {
    return this.http.post<CarteiraDeIntegradoresEstatisticas>(globals.apiUrl + '/api/CarteiraDeIntegradores/BuscarEstatisticas', filtro);
  }

  consultarRanking(filtro: CarteiraDeIntegradoresRankingFiltro) {
    return this.http.post<CarteiraDeIntegradoresItemRanking[]>(globals.apiUrl + '/api/CarteiraDeIntegradores/BuscarRanking', filtro);
  }

  consultarColunasOpcionais() {
    return this.http.get<any>(globals.apiUrl + '/api/CarteiraDeIntegradores/BuscarColunas');
  }

  consultarComPaginacao(filtro) {
    return this.http.post<any>(globals.apiUrl + '/api/CarteiraDeIntegradores/ListaPag', filtro);
  }

  exportar(filtro) {
    return this.http.post(globals.apiUrl + '/api/CarteiraDeIntegradores/Exportar', filtro , { responseType: 'blob' });
  }

  consultarTelemarketingComPaginacao(filtro) {
    return this.http.post<any>(globals.apiUrl + '/api/CarteiraDeIntegradores/MarketingListaPag', filtro);
  }
}
